<template>
  <div class="required-items-page">
    <div class="ri-toolbar">
      <div class="ri-toolbar__actions">
        <q-btn flat dense round icon="arrow_back" color="grey-7" @click="$router.push('/required')" />
        <q-chip v-if="sbsProjectName" dense color="blue-grey-1" text-color="blue-grey-8" icon="folder_open" size="sm">
          {{ sbsProjectName }}
        </q-chip>
        <q-separator vertical inset class="q-mx-xs" />
        <q-btn-group flat class="ri-expand-btns">
          <q-btn flat dense no-caps icon="unfold_more" size="sm" @click="expandAll" title="Развернуть все" />
          <q-btn flat dense no-caps icon="unfold_less" size="sm" @click="collapseAll" title="Свернуть все" />
        </q-btn-group>
        <q-separator vertical inset class="q-mx-xs" />
        <q-btn-toggle
          v-model="viewMode"
          no-caps dense unelevated
          toggle-color="teal-7"
          color="white"
          text-color="grey-8"
          :options="[
            { value: 'week', label: 'Недели' },
            { value: 'day', label: 'Дни' },
            { value: 'month', label: 'Месяцы' },
            { value: 'all', label: 'Все' },
          ]"
          class="ri-view-toggle"
        />
        <q-btn
          flat dense no-caps
          :icon="showPrihod ? 'visibility' : 'visibility_off'"
          :label="showPrihod ? 'Приход' : 'Приход'"
          size="sm"
          :color="showPrihod ? 'teal-7' : 'grey-6'"
          class="ri-prihod-toggle"
          @click="showPrihod = !showPrihod"
        >
          <q-tooltip>{{ showPrihod ? 'Скрыть столбцы Приход' : 'Показать столбцы Приход' }}</q-tooltip>
        </q-btn>
        <q-btn
          flat dense no-caps
          icon="bug_report"
          label="Без потреб."
          size="sm"
          :color="showWithoutRequired ? 'deep-orange-7' : 'grey-5'"
          @click="showWithoutRequired = !showWithoutRequired"
        >
          <q-tooltip>{{ showWithoutRequired ? 'Скрыть: заказано без потребности' : 'Показать: заказано без потребности' }}</q-tooltip>
        </q-btn>
        <q-select
          v-model="selectedMonths"
          :options="availableMonths"
          option-value="value"
          option-label="label"
          emit-value
          map-options
          multiple
          dense
          outlined
          clearable
          options-dense
          placeholder="Все месяцы"
          style="min-width: 150px; max-width: 260px; font-size: 12px"
          class="ri-month-filter"
        />

        <transition name="ri-fade">
          <div v-if="showMaterialSearch" class="ri-inline-search">
            <q-select
              ref="materialSearchRef"
              v-model="inlineSelectedMaterial"
              :options="filteredMaterials"
              option-value="material_id"
              option-label="material_name"
              :loading="isLoadingMaterials"
              use-input
              dense
              outlined
              placeholder="Поиск материала..."
              class="ri-inline-select"
              :options-dense="true"
              @filter="onFilterMaterials"
              @update:model-value="onInlineMaterialPick"
            >
              <template #prepend>
                <q-icon name="search" size="xs" color="grey-6" />
              </template>
              <template #append>
                <q-icon name="close" size="xs" class="cursor-pointer" @click.stop="closeMaterialSearch" />
              </template>
              <template #option="{ itemProps, opt }">
                <q-item
                  v-bind="itemProps"
                  dense
                  :disable="!!opt.is_used"
                  :class="{ 'ri-option--used': !!opt.is_used }"
                >
                  <q-item-section>
                    <q-item-label style="font-size:13px">{{ opt.material_name }}</q-item-label>
                    <q-item-label caption v-if="opt.unit_name">{{ opt.unit_name }}</q-item-label>
                  </q-item-section>
                  <q-item-section side v-if="opt.is_used">
                    <q-icon name="check_circle" color="positive" size="xs" />
                  </q-item-section>
                  <q-tooltip v-if="opt.is_used">Уже добавлен</q-tooltip>
                </q-item>
              </template>
              <template #no-option>
                <q-item>
                  <q-item-section class="text-grey text-center" style="font-size:13px">
                    {{ isLoadingMaterials ? 'Загрузка...' : 'Не найдено' }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
            <q-spinner-dots v-if="isSavingMaterial" color="teal-7" size="24px" class="q-ml-xs" />
          </div>
        </transition>

        <transition name="ri-fade">
          <div v-if="showTypeSearch" class="ri-inline-search">
            <q-select
              ref="typeSearchRef"
              v-model="inlineSelectedType"
              :options="filteredTypes"
              option-value="required_type_id"
              option-label="required_type_name"
              :loading="isLoadingTypes"
              use-input
              dense
              outlined
              placeholder="Поиск типа..."
              class="ri-inline-select"
              :options-dense="true"
              @filter="onFilterTypes"
              @update:model-value="onInlineTypePick"
            >
              <template #prepend>
                <q-icon name="search" size="xs" color="grey-6" />
              </template>
              <template #append>
                <q-icon name="close" size="xs" class="cursor-pointer" @click.stop="closeTypeSearch" />
              </template>
              <template #option="{ itemProps, opt }">
                <q-item
                  v-bind="itemProps"
                  dense
                  :disable="!!opt.is_used"
                  :class="{ 'ri-option--used': !!opt.is_used }"
                >
                  <q-item-section>
                    <q-item-label style="font-size:13px">{{ opt.required_type_name }}</q-item-label>
                  </q-item-section>
                  <q-item-section side v-if="opt.is_used">
                    <q-icon name="check_circle" color="positive" size="xs" />
                  </q-item-section>
                  <q-tooltip v-if="opt.is_used">Уже есть в потребностях</q-tooltip>
                </q-item>
              </template>
              <template #no-option>
                <q-item>
                  <q-item-section class="text-grey text-center" style="font-size:13px">
                    {{ isLoadingTypes ? 'Загрузка...' : 'Не найдено' }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
            <q-spinner-dots v-if="isSavingType" color="teal-7" size="24px" class="q-ml-xs" />
          </div>
        </transition>

        <div v-if="!showMaterialSearch && !showTypeSearch" class="ri-action-buttons">
          <span class="ri-btn-wrap">
            <q-btn
              outline no-caps dense
              :color="canEdit ? 'teal-7' : 'grey-5'"
              icon="add"
              label="Материал"
              class="ri-action-btn"
              :disable="!canEdit"
              @click="onAddMaterialClick"
            >
              <q-tooltip>{{ canEdit ? 'Добавить конкретный материал' : editTooltip }}</q-tooltip>
            </q-btn>
          </span>
          <span class="ri-btn-wrap">
            <q-btn
              outline no-caps dense
              :color="canEdit ? 'teal-7' : 'grey-5'"
              icon="group"
              label="Делегирование"
              class="ri-action-btn"
              :disable="!canEdit"
              @click="openDelegatesDialog"
            >
              <q-tooltip>{{ canEdit ? 'Управление делегатами' : editTooltip }}</q-tooltip>
            </q-btn>
          </span>
        </div>
        <q-space />
        <span class="ri-btn-wrap">
        <q-btn
          no-caps dense unelevated
          :color="canEdit && hasUnapprovedItems ? 'teal-7' : 'grey-5'"
          label="Отправить снабженцу"
          icon="send"
          class="ri-approve-btn"
          :loading="isApproving"
          :disable="!canEdit || !hasUnapprovedItems"
          @click="onApprove"
        >
          <q-tooltip>{{ !canEdit ? 'Отправить может только автор или делегат с правом редактирования' : !hasUnapprovedItems ? 'Нет неотправленных изменений' : 'Отправить на согласование' }}</q-tooltip>
        </q-btn>
        </span>
      </div>
    </div>

    <div v-if="progressData && progressData.smeta" class="ri-progress-section">
      <div class="ri-progress-bar">
        <div class="ri-progress-segment ri-progress--required" :style="{ width: progressBarWidth('required') }"></div>
        <div class="ri-progress-segment ri-progress--ordered" :style="{ width: progressBarWidth('ordered') }"></div>
        <div class="ri-progress-segment ri-progress--delivered" :style="{ width: progressBarWidth('delivered') }"></div>
        <q-tooltip class="ri-progress-tooltip">
          <div class="ri-tooltip-row"><span class="ri-tooltip-dot" style="background:#fb8c00"></span> Потребность: {{ fmtNum(progressData.required) }} ({{ fmtNum(progressPct('required')) }}%)</div>
          <div class="ri-tooltip-row"><span class="ri-tooltip-dot" style="background:#1e88e5"></span> Заказано: {{ fmtNum(progressData.ordered) }} ({{ fmtNum(progressPct('ordered')) }}%)</div>
          <div class="ri-tooltip-row"><span class="ri-tooltip-dot" style="background:#43a047"></span> Доставлено: {{ fmtNum(progressData.delivered) }} ({{ fmtNum(progressPct('delivered')) }}%)</div>
          <div class="ri-tooltip-row"><span class="ri-tooltip-dot" style="background:#bdbdbd"></span> Смета: {{ fmtNum(progressData.smeta) }}</div>
        </q-tooltip>
      </div>
      <div class="ri-progress-legend">
        <div class="ri-legend-item" v-if="progressData.required > 0">
          <span class="ri-legend-dot" style="background:#fb8c00"></span>
          <span class="ri-legend-text">Потребность: {{ fmtNum(progressData.required) }} ({{ fmtNum(progressPct('required')) }}%)</span>
        </div>
        <div class="ri-legend-item" v-if="progressData.ordered > 0">
          <span class="ri-legend-dot" style="background:#1e88e5"></span>
          <span class="ri-legend-text">Заказано: {{ fmtNum(progressData.ordered) }} ({{ fmtNum(progressPct('ordered')) }}%)</span>
        </div>
        <div class="ri-legend-item" v-if="progressData.delivered > 0">
          <span class="ri-legend-dot" style="background:#43a047"></span>
          <span class="ri-legend-text">Доставлено: {{ fmtNum(progressData.delivered) }} ({{ fmtNum(progressPct('delivered')) }}%)</span>
        </div>
        <div class="ri-legend-item">
          <span class="ri-legend-dot" style="background:#e0e0e0"></span>
          <span class="ri-legend-text">Смета: {{ fmtNum(progressData.smeta) }}</span>
        </div>
      </div>
    </div>

    <div v-if="isLoading" class="ri-loader">
      <q-spinner-dots color="teal-7" size="48px" />
      <div class="ri-loader__text">Загрузка данных...</div>
    </div>

    <div v-if="!isLoading" class="required-items-table-wrapper">
      <table class="ri-table">
        <thead ref="thead">
          <tr ref="headerRow1">
            <th rowspan="3" class="ri-th ri-th--fixed ri-sticky ri-sticky--0">#</th>
            <th rowspan="3" class="ri-th ri-th--fixed ri-th--name ri-sticky ri-sticky--1">
              <q-icon name="inventory_2" size="16px" color="blue-grey-5" />
              <q-tooltip :delay="200">Наименование</q-tooltip>
            </th>
            <th rowspan="3" class="ri-th ri-th--fixed ri-sticky ri-sticky--2">
              <q-icon name="assignment" size="16px" style="color:#e65100" />
              <q-tooltip :delay="200">Потребность / Смета</q-tooltip>
            </th>
            <th rowspan="3" class="ri-th ri-th--fixed ri-sticky ri-sticky--3">
              <q-icon name="add_shopping_cart" size="16px" style="color:#1565c0" />
              <q-tooltip :delay="200">Потребность / Заказано из потребности</q-tooltip>
            </th>
            <th rowspan="3" class="ri-th ri-th--fixed ri-sticky ri-sticky--4">
              <q-icon name="local_shipping" size="16px" style="color:#2e7d32" />
              <q-tooltip :delay="200">Доставлено / Заказано</q-tooltip>
            </th>
            <th rowspan="3" class="ri-th ri-th--fixed ri-sticky ri-sticky--5 ri-th--avail">
              <span class="ri-th-avail-lines">
                <span class="ri-th-avail-line">Доступно</span>
                <span class="ri-th-avail-line">для</span>
                <span class="ri-th-avail-line">заказа</span>
              </span>
              <q-tooltip :delay="200">Остаток сметы (Смета − Потребность − Заказано)</q-tooltip>
            </th>
            <th v-show="showWithoutRequired" rowspan="3" class="ri-th ri-th--fixed ri-sticky ri-sticky--6">
              <q-icon name="shopping_cart_off" size="16px" style="color:#6d4c41" />
              <q-tooltip :delay="200">Заказано без потребности</q-tooltip>
            </th>
            <th
              v-for="group in displayGroups"
              :key="group.key"
              :colspan="group.colCount * (showPrihod ? 2 : 1)"
              class="ri-th ri-th--month"
              :class="'ri-month--' + group.monthIdx"
            >
              <span class="ri-month-label">{{ group.label }}</span>
            </th>
          </tr>
          <tr ref="headerRow2">
            <th
              v-for="col in displayColumns"
              :key="col.key"
              :colspan="showPrihod ? 2 : 1"
              class="ri-th ri-th--day"
              :class="'ri-month--' + col.monthIdx"
              :style="{ top: headerRow1Height + 'px' }"
            >
              {{ col.label }}
            </th>
          </tr>
          <tr>
            <template v-for="col in displayColumns" :key="'s-' + col.key">
              <th class="ri-th ri-th--sub" :class="'ri-month--' + col.monthIdx" :style="{ top: (headerRow1Height + headerRow2Height) + 'px' }">Кол-во</th>
              <th v-show="showPrihod" class="ri-th ri-th--sub" :class="'ri-month--' + col.monthIdx" :style="{ top: (headerRow1Height + headerRow2Height) + 'px' }">Приход</th>
            </template>
          </tr>
        </thead>
        <tbody v-if="isLevel" ref="levelBody">
          <tr
            class="ri-row ri-row--levels"
            :class="canEdit ? 'ri-row--levels-clickable' : 'ri-row--levels-disabled'"
            :style="{ '--header-h': theadHeight + 'px' }"
            @click="canEdit && openLevelDialog()"
          >
            <td class="ri-td ri-td--level-sticky ri-sticky ri-sticky--0"></td>
            <td class="ri-td ri-td--level-sticky ri-td--level-label ri-sticky ri-sticky--1">
              <q-icon name="layers" size="xs" class="q-mr-xs" />
              Этажи
              <q-icon v-if="canEdit" name="edit" size="12px" class="ri-level-edit-icon" />
              <q-tooltip v-if="!canEdit">{{ editTooltip }}</q-tooltip>
            </td>
            <td class="ri-td ri-td--level-sticky ri-sticky ri-sticky--2"></td>
            <td class="ri-td ri-td--level-sticky ri-sticky ri-sticky--3"></td>
            <td class="ri-td ri-td--level-sticky ri-sticky ri-sticky--4"></td>
            <td class="ri-td ri-td--level-sticky ri-sticky ri-sticky--5"></td>
            <td v-show="showWithoutRequired" class="ri-td ri-td--level-sticky ri-sticky ri-sticky--6"></td>
            <td
              v-for="col in displayColumns"
              :key="'lvl-' + col.key"
              :colspan="showPrihod ? 2 : 1"
              class="ri-td ri-td--level-sticky ri-td--level-cell"
              :class="['ri-month--' + col.monthIdx, levelByColumn[col.key] ? 'ri-td--level-assigned' : '']"
            >
              <span v-if="levelByColumn[col.key]" class="ri-level-num">{{ levelByColumn[col.key] }}</span>
            </td>
          </tr>
        </tbody>
        <tbody v-for="(mat, idx) in materials" :key="mat.material_id">
            <tr
              class="ri-row ri-row--material"
              :class="{ 'ri-row--material-sticky': expanded[mat.material_id] }"
              :style="expanded[mat.material_id] ? { '--thead-h': (theadHeight + levelBodyHeight) + 'px' } : {}"
              @click="toggleExpand(mat.material_id)"
            >
              <td class="ri-td ri-sticky ri-sticky--0">{{ idx + 1 }}</td>
              <td class="ri-td ri-td--name ri-sticky ri-sticky--1">
                <div class="ri-name-cell">
                  <q-icon
                    :name="expanded[mat.material_id] ? 'expand_less' : 'expand_more'"
                    size="sm"
                    class="expand-icon"
                  />
                  <span class="ri-name-text">{{ mat.material_name }}</span>
                  <span class="ri-btn-wrap">
                    <q-btn
                      flat dense round
                      icon="delete_outline"
                      size="xs"
                      :color="canEdit ? 'negative' : 'grey-5'"
                      class="ri-delete-btn"
                      :disable="!canEdit"
                      @click.stop="onDeleteMaterial(mat)"
                    >
                      <q-tooltip>{{ canEdit ? 'Удалить материал' : editTooltip }}</q-tooltip>
                    </q-btn>
                  </span>
                </div>
              </td>
              <td class="ri-td ri-td--num ri-sticky ri-sticky--2">
                <span class="ri-val ri-val--required">{{ fmtNum(mat.total_required) }}</span><span class="ri-val--slash"> / </span><span class="ri-val--denom ri-val--smeta-link" @click.stop="openSmetaDetail(mat)">{{ fmtNum(mat.smeta_amount) }}</span> <span class="ri-val--unit">{{ mat.unit_name }}</span>
                <q-tooltip :delay="200">Потребность / Смета (нажмите на смету для расшифровки)</q-tooltip>
              </td>
              <td class="ri-td ri-td--num ri-sticky ri-sticky--3">
                <span class="ri-val ri-val--ordered">{{ fmtNum(mat.total_required) }}</span><span class="ri-val--slash"> / </span><span class="ri-val--denom">{{ fmtNum(mat.ordered_from_required) }}</span>
                <q-tooltip :delay="200">Потребность / Заказано из потребности</q-tooltip>
              </td>
              <td class="ri-td ri-td--num ri-sticky ri-sticky--4" :class="{ 'ri-td--complete': mat.total_ordered > 0 && mat.total_delivered >= mat.total_ordered }">
                <span class="ri-val ri-val--delivered">{{ fmtNum(mat.total_delivered) }}</span><span class="ri-val--slash"> / </span><span class="ri-val--denom">{{ fmtNum(mat.total_ordered) }}</span>
                <q-tooltip :delay="200">Доставлено / Заказано</q-tooltip>
              </td>
              <td class="ri-td ri-td--num ri-sticky ri-sticky--5 ri-td--avail-col">
                <template v-if="mat.smeta_amount - mat.total_required - mat.ordered_without_required <= 0">
                  <q-icon name="block" size="16px" class="text-negative" />
                </template>
                <span v-else class="ri-val">{{ fmtNum(mat.smeta_amount - mat.total_required - mat.ordered_without_required) }}</span>
                <q-tooltip :delay="200">
                  Смета ({{ fmtNum(mat.smeta_amount) }}) − Потребность ({{ fmtNum(mat.total_required) }}) − Заказано без потреб. ({{ fmtNum(mat.ordered_without_required) }}) = {{ fmtNum(mat.smeta_amount - mat.total_required - mat.ordered_without_required) }}
                </q-tooltip>
              </td>
              <td v-show="showWithoutRequired" class="ri-td ri-td--num ri-sticky ri-sticky--6">
                <span class="ri-val">{{ fmtNum(mat.ordered_without_required) }}</span>
                <q-tooltip :delay="200">Заказано без потребности</q-tooltip>
              </td>
              <template v-for="col in displayColumns" :key="col.key">
                <td class="ri-td ri-td--date"
                    :class="[canEdit && !(isMatBlocked(mat) && !getColAggregatedVal(mat._dateMap, col, 'amount')) && viewMode !== 'all' && viewMode !== 'month' && !isMatCellReadonly(mat, col) ? 'ri-td--input' : 'ri-td--num',
                             'ri-month--' + col.monthIdx,
                             isPhase1PastLocked(col.dates[0]) ? 'ri-td--past' : '', isPhase2SendHorizonLocked(col.dates[0]) ? 'ri-td--past' : '', isColAllApproved(mat, col) ? 'ri-td--approved' : '']">
                  <template v-if="isMatCellReadonly(mat, col)">
                    {{ getColAggregatedVal(mat._dateMap, col, 'amount') }}
                    <q-tooltip v-if="isPhase1PastLocked(col.dates[0]) && canEdit">
                      Редактирование до первой отправки снабженцу недоступно для прошлых дат
                    </q-tooltip>
                    <q-tooltip v-else-if="isPhase2SendHorizonLocked(col.dates[0]) && canEdit">
                      {{ lastSendHorizonTooltip }}
                    </q-tooltip>
                    <q-tooltip v-else-if="isColAllApproved(mat, col) && canEdit">
                      Позиция отправлена снабженцу
                    </q-tooltip>
                  </template>
                  <input
                    v-else
                    type="number"
                    class="cell-input"
                    :value="getColAggregatedVal(mat._dateMap, col, 'amount') || ''"
                    @click.stop
                    @blur="onMatAmountBlur($event, mat, col)"
                    @keydown.enter="$event.target.blur()"
                  />
                </td>
                <td v-show="showPrihod" class="ri-td ri-td--num ri-td--date" :class="['ri-month--' + col.monthIdx, isPhase1PastLocked(col.dates[0]) ? 'ri-td--past' : '', isPhase2SendHorizonLocked(col.dates[0]) ? 'ri-td--past' : '', isColAllApproved(mat, col) ? 'ri-td--approved' : '']">
                  {{ getColAggregatedVal(mat._dateMap, col, 'delivered') }}
                </td>
              </template>
            </tr>

            <template v-if="expanded[mat.material_id]">
              <tr
                v-for="entry in mat.entries"
                :key="`${mat.material_id}-${entry.entrance}-${entry.level_num}`"
                class="ri-row ri-row--entry"
              >
                <td class="ri-td ri-sticky ri-sticky--0"></td>
                <td class="ri-td ri-td--entry-name ri-sticky ri-sticky--1">
                  {{ entry.label }}
                  <q-chip v-if="isPreorder" dense color="deep-orange-1" text-color="deep-orange-8" size="xs" class="q-ml-xs ri-chip--preorder">
                    Предзаказ
                  </q-chip>
                </td>
                <td class="ri-td ri-td--num ri-sticky ri-sticky--2">
                  <span class="ri-val ri-val--required">{{ fmtNum(entry.total_required) }}</span><span class="ri-val--slash"> / </span><span class="ri-val--denom">{{ fmtNum(entry.smeta_cap) }}</span> <span class="ri-val--unit">{{ entry.unit_name }}</span>
                  <q-tooltip :delay="200">Потребность / Смета</q-tooltip>
                </td>
                <td class="ri-td ri-td--num ri-sticky ri-sticky--3">
                  <span class="ri-val ri-val--ordered">{{ fmtNum(entry.total_required) }}</span><span class="ri-val--slash"> / </span><span class="ri-val--denom">{{ fmtNum(getEntryAllocatedOrderedFromRequired(mat, entry)) }}</span>
                  <q-tooltip :delay="200">Потребность / Заказано из потребности</q-tooltip>
                </td>
                <td class="ri-td ri-td--num ri-sticky ri-sticky--4">
                  <span class="ri-val ri-val--delivered">{{ fmtNum(getEntryAllocatedDelivered(mat, entry)) }}</span><span class="ri-val--slash"> / </span><span class="ri-val--denom">{{ fmtNum(getEntryAllocatedOrdered(mat, entry)) }}</span>
                  <q-tooltip :delay="200">Доставлено / Заказано</q-tooltip>
                </td>
                <td class="ri-td ri-sticky ri-sticky--5"></td>
                <td v-show="showWithoutRequired" class="ri-td ri-td--num ri-sticky ri-sticky--6">
                  <span class="ri-val">{{ fmtNum(getEntryAllocatedOrderedWithoutRequired(mat, entry)) }}</span>
                  <q-tooltip :delay="200">Заказано без потребности</q-tooltip>
                </td>
                <template v-for="col in displayColumns" :key="col.key">
                  <template v-if="viewMode === 'day'">
                    <td class="ri-td" :class="[isDayCellReadonly(entry, col, mat) ? 'ri-td--num ri-td--readonly' : 'ri-td--input', isPhase1PastLocked(col.dates[0]) ? 'ri-td--past' : '', isPhase2SendHorizonLocked(col.dates[0]) ? 'ri-td--past' : '', lastApprovedDate && isDateApproved(entry, col.dates[0]) ? 'ri-td--approved' : '', 'ri-month--' + col.monthIdx, isDateComplete(entry, col.dates[0]) ? 'ri-td--has-value' : '']">
                      <template v-if="isDayCellReadonly(entry, col, mat)">
                        {{ getEntryAmount(entry, col.dates[0]) }}
                        <q-tooltip v-if="isPhase1PastLocked(col.dates[0]) && canEdit">
                          Редактирование до первой отправки снабженцу недоступно для прошлых дат
                        </q-tooltip>
                        <q-tooltip v-else-if="isPhase2SendHorizonLocked(col.dates[0]) && canEdit">
                          {{ lastSendHorizonTooltip }}
                        </q-tooltip>
                        <q-tooltip v-else-if="isDateApproved(entry, col.dates[0]) && canEdit">
                          Позиция отправлена снабженцу
                        </q-tooltip>
                        <q-tooltip v-else-if="isMatBlocked(mat) && !getEntryAmount(entry, col.dates[0]) && !isEditLocked(entry, col.dates[0], mat) && canEdit">
                          Смета по материалу исчерпана
                        </q-tooltip>
                        <q-tooltip v-else-if="isEntryOrderFull(mat, entry) && !isEditLocked(entry, col.dates[0], mat) && canEdit">
                          Потребность по блоку исчерпана (достигнута смета)
                        </q-tooltip>
                      </template>
                      <input
                        v-else
                        type="number"
                        class="cell-input"
                        :value="getEntryAmount(entry, col.dates[0])"
                        @blur="onAmountBlur($event, mat, entry, col.dates[0])"
                        @keydown.enter="$event.target.blur()"
                      />
                    </td>
                    <td v-show="showPrihod" class="ri-td ri-td--num ri-td--delivered" :class="['ri-month--' + col.monthIdx, isDateComplete(entry, col.dates[0]) ? 'ri-td--has-value' : '', isDateBeforeToday(col.dates[0]) ? 'ri-td--past' : '']">
                      {{ getEntryDelivered(entry, col.dates[0]) }}
                    </td>
                  </template>
                  <template v-else-if="viewMode === 'week'">
                    <td class="ri-td" :class="[isWeekCellReadonly(entry, col, mat) ? 'ri-td--num ri-td--readonly' : 'ri-td--input', isPhase1PastLocked(col.dates[0]) ? 'ri-td--past' : '', isPhase2SendHorizonLocked(col.dates[0]) ? 'ri-td--past' : '', lastApprovedDate && isDateApproved(entry, col.dates[0]) ? 'ri-td--approved' : '', 'ri-month--' + col.monthIdx, isWeekComplete(entry, col) ? 'ri-td--has-value' : '']">
                      <template v-if="isWeekCellReadonly(entry, col, mat)">
                        {{ getColAggregatedVal(entry._dateItems, col, 'amount') }}
                        <q-tooltip v-if="isPhase1PastLocked(col.dates[0]) && canEdit">
                          Редактирование до первой отправки снабженцу недоступно для прошлых дат
                        </q-tooltip>
                        <q-tooltip v-else-if="isPhase2SendHorizonLocked(col.dates[0]) && canEdit">
                          {{ lastSendHorizonTooltip }}
                        </q-tooltip>
                        <q-tooltip v-else-if="isDateApproved(entry, col.dates[0]) && canEdit">
                          Позиция отправлена снабженцу
                        </q-tooltip>
                        <q-tooltip v-else-if="isMatBlocked(mat) && !getColAggregatedVal(entry._dateItems, col, 'amount') && !isEditLocked(entry, col.dates[0], mat) && canEdit && !hasNonMondayValues(entry, col)">
                          Смета по материалу исчерпана
                        </q-tooltip>
                        <q-tooltip v-else-if="isEntryOrderFull(mat, entry) && !isEditLocked(entry, col.dates[0], mat) && canEdit && !hasNonMondayValues(entry, col)">
                          Потребность по блоку исчерпана (достигнута смета)
                        </q-tooltip>
                      </template>
                      <input
                        v-else
                        type="number"
                        class="cell-input"
                        :value="getColAggregatedVal(entry._dateItems, col, 'amount')"
                        @blur="onWeekAmountBlur($event, mat, entry, col)"
                        @keydown.enter="$event.target.blur()"
                      />
                    </td>
                    <td v-show="showPrihod" class="ri-td ri-td--num ri-td--delivered" :class="['ri-month--' + col.monthIdx, isWeekComplete(entry, col) ? 'ri-td--has-value' : '', isDateBeforeToday(col.dates[0]) ? 'ri-td--past' : '']">
                      {{ getColAggregatedVal(entry._dateItems, col, 'delivered') }}
                    </td>
                  </template>
                  <template v-else>
                    <td class="ri-td ri-td--num ri-td--readonly" :class="['ri-month--' + col.monthIdx, isPhase1PastLocked(col.dates[0]) ? 'ri-td--past' : '', isPhase2SendHorizonLocked(col.dates[0]) ? 'ri-td--past' : '', lastApprovedDate && isDateApproved(entry, col.dates[0]) ? 'ri-td--approved' : '']">
                      {{ getColAggregatedVal(entry._dateItems, col, 'amount') }}
                    </td>
                    <td v-show="showPrihod" class="ri-td ri-td--num ri-td--readonly ri-td--delivered" :class="'ri-month--' + col.monthIdx">
                      {{ getColAggregatedVal(entry._dateItems, col, 'delivered') }}
                    </td>
                  </template>
                </template>
              </tr>
            </template>
        </tbody>
      </table>
    </div>

    <q-dialog v-model="showLevelDialog">
      <q-card class="ri-level-dialog">
        <q-card-section class="ri-level-dialog__header">
          <div class="text-subtitle1 text-weight-medium">Назначить этажи</div>
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section class="ri-level-dialog__body">
          <div class="ri-level-grid">
            <div
              v-for="lv in levels"
              :key="lv.level_num"
              class="ri-level-row"
            >
              <div class="ri-level-row__label">{{ lv.level_name }}</div>
              <q-input
                v-model="levelDates[lv.level_num].start"
                dense outlined
                label="Начало"
                class="ri-level-date"
                mask="##.##.####"
                placeholder="ДД.ММ.ГГГГ"
              >
                <template #append>
                  <q-icon name="event" class="cursor-pointer" size="xs">
                    <q-popup-proxy transition-show="scale" transition-hide="scale">
                      <q-date
                        v-model="levelDates[lv.level_num].start"
                        mask="DD.MM.YYYY"
                        :navigation-min-year-month="minYearMonth"
                        :navigation-max-year-month="maxYearMonth"
                        minimal
                        @update:model-value="onLevelDateChange(lv.level_num)"
                      />
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                v-model="levelDates[lv.level_num].end"
                dense outlined
                label="Конец"
                class="ri-level-date"
                mask="##.##.####"
                placeholder="ДД.ММ.ГГГГ"
              >
                <template #append>
                  <q-icon name="event" class="cursor-pointer" size="xs">
                    <q-popup-proxy transition-show="scale" transition-hide="scale">
                      <q-date
                        v-model="levelDates[lv.level_num].end"
                        mask="DD.MM.YYYY"
                        :navigation-min-year-month="minYearMonth"
                        :navigation-max-year-month="maxYearMonth"
                        minimal
                        @update:model-value="onLevelDateChange(lv.level_num)"
                      />
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-btn
                flat dense round
                icon="delete_outline"
                size="sm"
                color="grey-6"
                :disable="!levelDates[lv.level_num].id"
                @click="deleteLevelRange(lv.level_num)"
              >
                <q-tooltip>Очистить</q-tooltip>
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="delegatesDialog" persistent>
      <q-card style="min-width: 720px; max-width: 920px;">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Делегирование</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div v-if="delegatesLoading" class="column items-center q-pa-lg">
            <q-spinner color="teal-7" size="40px" />
            <div class="q-mt-sm">Загрузка данных...</div>
          </div>

          <div v-else>
            <div class="row q-col-gutter-sm items-end">
              <div class="col-12 col-md-7">
                <q-select
                  v-model="newDelegateEmployeeId"
                  :options="filteredDelegateEmployees"
                  option-value="employee_id"
                  option-label="fio"
                  emit-value
                  map-options
                  dense
                  outlined
                  use-input
                  input-debounce="0"
                  label="Сотрудник"
                  :loading="isLoadingDelegateEmployees"
                  @filter="onFilterDelegateEmployees"
                  clearable
                />
              </div>
              <div class="col-12 col-md-3">
                <q-checkbox
                  v-model="newDelegateCanView"
                  label="Просмотр"
                  :disable="newDelegateCanEdit"
                />
              </div>
              <div class="col-12 col-md-2">
                <q-checkbox
                  v-model="newDelegateCanEdit"
                  label="Редакт."
                  @update:model-value="onNewDelegateEditToggle"
                />
              </div>
              <div class="col-12">
                <q-btn
                  unelevated
                  no-caps
                  color="teal-7"
                  :disable="!newDelegateEmployeeId || (!newDelegateCanView && !newDelegateCanEdit) || isSavingDelegate"
                  :loading="isSavingDelegate"
                  label="Добавить / обновить"
                  @click="saveNewDelegate"
                />
              </div>
            </div>

            <q-separator class="q-my-md" />

            <div class="text-subtitle2 q-mb-sm">Делегаты</div>
            <div v-if="!delegates.length" class="text-grey-6">Нет делегатов</div>

            <q-list v-else bordered separator>
              <q-item v-for="d in delegates" :key="d.required_delegate_id">
                <q-item-section>
                  <q-item-label>{{ d.delegate_fio || d.delegate_employee_id }}</q-item-label>
                  <q-item-label caption>id: {{ d.delegate_employee_id }}</q-item-label>
                </q-item-section>

                <q-item-section side>
                  <q-checkbox
                    v-model="d.can_view"
                    label="Просмотр"
                    dense
                    :disable="d.can_edit"
                    @update:model-value="() => onDelegateViewToggle(d)"
                  />
                </q-item-section>
                <q-item-section side>
                  <q-checkbox
                    v-model="d.can_edit"
                    label="Редакт."
                    dense
                    @update:model-value="() => onDelegateEditToggle(d)"
                  />
                </q-item-section>

                <q-item-section side>
                  <q-btn
                    flat dense round
                    icon="save"
                    :color="'teal-7'"
                    :disable="isSavingDelegate || (!d.can_view && !d.can_edit)"
                    :loading="savingDelegateEmployeeId === d.delegate_employee_id"
                    @click="saveDelegateRow(d)"
                  >
                    <q-tooltip>Сохранить</q-tooltip>
                  </q-btn>
                </q-item-section>
                <q-item-section side>
                  <q-btn
                    flat dense round
                    icon="delete_outline"
                    color="negative"
                    :loading="deletingDelegateId === d.required_delegate_id"
                    :disable="isSavingDelegate"
                    @click="deleteDelegateRow(d)"
                  >
                    <q-tooltip>Удалить</q-tooltip>
                  </q-btn>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="smetaDetailDialog" max-width="900px">
      <q-card style="min-width: 640px; max-width: 900px;">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-subtitle1 text-weight-medium">
            Расшифровка сметы: {{ smetaDetailMat?.material_name }}
          </div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section>
          <div v-if="smetaDetailLoading" class="flex flex-center q-pa-md">
            <q-spinner size="32px" />
          </div>
          <table v-else class="smeta-detail-table">
            <thead>
              <tr>
                <th>Проект</th>
                <th>Тип проекта</th>
                <th class="text-right">Смета (wcheck)</th>
                <th class="text-right">Предзаказ</th>
                <th class="text-right">Итого</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in smetaDetailRows" :key="row.project_id">
                <td>{{ row.project_short_name || row.project_name }}</td>
                <td>{{ row.project_type_name }}</td>
                <td class="text-right">{{ fmtNum(row.smeta_amount) }}</td>
                <td class="text-right">{{ fmtNum(row.preorder_amount) }}</td>
                <td class="text-right text-weight-medium">{{ fmtNum((row.smeta_amount || 0) + (row.preorder_amount || 0)) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="smeta-detail-total">
                <td colspan="2"><strong>Итого</strong></td>
                <td class="text-right"><strong>{{ fmtNum(smetaDetailRows.reduce((s, r) => s + (r.smeta_amount || 0), 0)) }}</strong></td>
                <td class="text-right"><strong>{{ fmtNum(smetaDetailRows.reduce((s, r) => s + (r.preorder_amount || 0), 0)) }}</strong></td>
                <td class="text-right"><strong>{{ fmtNum(smetaDetailRows.reduce((s, r) => s + (r.smeta_amount || 0) + (r.preorder_amount || 0), 0)) }}</strong></td>
              </tr>
            </tfoot>
          </table>
          <div v-if="!smetaDetailLoading && !smetaDetailRows.length" class="text-grey text-center q-pa-md">
            Нет данных
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>

  </div>
</template>

<script>
import instance from "@/services/api";

export default {
  name: "RequiredItems",
  props: {
    id: [String, Number],
  },
  data() {
    return {
      materials: [],
      calendarDates: [],
      isLoading: false,
      progressData: null,
      expanded: {},
      viewMode: 'week',
      requiredName: '',
      sbsProjectName: '',
      dateBegin: null,
      dateEnd: null,
      isLevel: false,
      levels: [],
      levelRanges: [],
      isLoadingLevels: false,
      showMaterialSearch: false,
      isLoadingMaterials: false,
      isSavingMaterial: false,
      availableMaterials: [],
      filteredMaterials: [],
      inlineSelectedMaterial: null,
      showTypeSearch: false,
      isLoadingTypes: false,
      isSavingType: false,
      availableTypes: [],
      filteredTypes: [],
      inlineSelectedType: null,
      theadHeight: 0,
      levelBodyHeight: 0,
      headerRow1Height: 0,
      headerRow2Height: 0,
      showLevelDialog: false,
      levelDates: {},
      _refreshTimer: null,
      _pendingSaves: 0,
      isApproving: false,
      showPrihod: false,
      showWithoutRequired: false,
      selectedMonths: [],
      canEdit: true,
      lastApprovedDate: null,
      isPreorder: false,
      smetaDetailDialog: false,
      smetaDetailMat: null,
      smetaDetailRows: [],
      smetaDetailLoading: false,
      delegatesDialog: false,
      delegatesLoading: false,
      delegates: [],
      delegateEmployees: [],
      filteredDelegateEmployees: [],
      isLoadingDelegateEmployees: false,
      newDelegateEmployeeId: null,
      newDelegateCanView: true,
      newDelegateCanEdit: false,
      isSavingDelegate: false,
      savingDelegateEmployeeId: null,
      deletingDelegateId: null,
    };
  },
  computed: {
    availableMonths() {
      const seen = new Set();
      const result = [];
      for (const d of this.calendarDates) {
        const [y, m] = d.split('-');
        const key = `${y}-${m}`;
        if (!seen.has(key)) {
          seen.add(key);
          result.push({
            value: key,
            label: new Date(+y, +m - 1, 1).toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' }),
          });
        }
      }
      return result;
    },

    filteredCalendarDates() {
      if (!this.selectedMonths?.length) return this.calendarDates;
      return this.calendarDates.filter(d => {
        const [y, m] = d.split('-');
        return this.selectedMonths.includes(`${y}-${m}`);
      });
    },

    displayColumns() {
      let cols;

      const dates = this.filteredCalendarDates;

      if (this.viewMode === 'day') {
        cols = dates.map(d => {
          const p = d.split('-');
          return { key: d, label: `${parseInt(p[2])}.${p[1]}`, dates: [d] };
        });
      } else if (this.viewMode === 'week') {
        cols = [];
        let cur = null;
        for (const d of dates) {
          const wk = this.getWeekKey(d);
          if (!cur || cur.key !== wk) {
            cur = { key: wk, dates: [] };
            cols.push(cur);
          }
          cur.dates.push(d);
        }
        for (const w of cols) {
          w.label = `${this.formatShortDate(w.dates[0])} - ${this.formatShortDate(w.dates[w.dates.length - 1])}`;
        }
      } else if (this.viewMode === 'month') {
        cols = [];
        let cur = null;
        for (const d of dates) {
          const p = d.split('-');
          const mk = `${p[0]}-${p[1]}`;
          if (!cur || cur.key !== mk) {
            const dt = new Date(parseInt(p[0]), parseInt(p[1]) - 1, 1);
            cur = {
              key: mk,
              label: dt.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' }),
              dates: [],
            };
            cols.push(cur);
          }
          cur.dates.push(d);
        }
      } else {
        cols = [{ key: 'all', label: 'Итого', dates: [...dates] }];
      }

      let idx = 0;
      let prevMk = null;
      for (const col of cols) {
        const p = col.dates[0].split('-');
        const mk = `${p[0]}-${p[1]}`;
        if (prevMk !== null && mk !== prevMk) idx = 1 - idx;
        prevMk = mk;
        col.monthIdx = idx;
      }
      return cols;
    },

    displayGroups() {
      if (this.viewMode === 'month' || this.viewMode === 'all') {
        return this.displayColumns.map(col => ({
          key: col.key,
          label: col.label,
          colCount: 1,
          monthIdx: col.monthIdx,
        }));
      }

      const groups = [];
      let currentKey = null;
      let currentGroup = null;
      for (const col of this.displayColumns) {
        const p = col.dates[0].split('-');
        const mk = `${p[0]}-${p[1]}`;
        if (mk !== currentKey) {
          currentKey = mk;
          const dt = new Date(parseInt(p[0]), parseInt(p[1]) - 1, 1);
          currentGroup = {
            key: mk,
            label: dt.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' }),
            colCount: 0,
            monthIdx: col.monthIdx,
          };
          groups.push(currentGroup);
        }
        currentGroup.colCount++;
      }
      return groups;
    },

    minYearMonth() {
      if (!this.dateBegin) return undefined;
      const p = this.dateBegin.split('-');
      return `${p[0]}/${p[1]}`;
    },

    maxYearMonth() {
      if (!this.dateEnd) return undefined;
      const p = this.dateEnd.split('-');
      return `${p[0]}/${p[1]}`;
    },

    editTooltip() {
      return this.canEdit ? '' : 'Редактировать может только автор или делегат с правом редактирования';
    },

    levelByColumn() {
      const map = {};
      for (const col of this.displayColumns) {
        const colStart = col.dates[0];
        const colEnd = col.dates[col.dates.length - 1];
        const found = this.levelRanges.find(
          lr => lr.start_date <= colEnd && lr.end_date >= colStart
        );
        if (found) {
          map[col.key] = found.level_num;
        }
      }
      return map;
    },

    hasUnapprovedItems() {
      for (const mat of this.materials) {
        for (const entry of mat.entries || []) {
          for (const item of Object.values(entry._dateItems)) {
            if (item.required_item_id && !item.approved) return true;
          }
        }
      }
      return false;
    },

    lastSendHorizonTooltip() {
      if (!this.lastApprovedDate) return '';
      const p = this.lastApprovedDate.split('-');
      if (p.length !== 3) {
        return 'Редактирование заблокировано до последней отправки снабженцу';
      }
      return `Редактирование заблокировано до последней отправки снабженцу (до ${p[2]}.${p[1]}.${p[0]} включительно)`;
    },

  },
  mounted() {
    this.loadData();
  },
  beforeUnmount() {
    if (this._refreshTimer) clearTimeout(this._refreshTimer);
  },
  methods: {
    fmtNum(v) {
      if (v == null || v === '') return '';
      const n = Number(v);
      if (isNaN(n)) return v;
      return parseFloat(n.toFixed(2));
    },
    progressPct(type) {
      if (!this.progressData || !this.progressData.smeta) return 0;
      const val = this.progressData[type] || 0;
      return Math.min(parseFloat((val / this.progressData.smeta * 100).toFixed(1)), 100);
    },
    progressBarWidth(type) {
      const pct = this.progressPct(type);
      if (pct <= 0) return '0';
      const minPx = { required: 24, ordered: 16, delivered: 8 };
      return `max(${pct}%, ${minPx[type] || 8}px)`;
    },
    async loadData() {
      this.isLoading = true;
      try {
        const [itemsResp, progressResp] = await Promise.all([
          instance().get(`/required/${this.id}/items/`),
          instance().get(`/required/${this.id}/progress/`).catch(() => null),
        ]);
        const data = itemsResp.data;
        const raw = data?.data || [];
        this.requiredName = data?.required_name || '';
        this.sbsProjectName = data?.sbs_project_name || '';
        this.dateBegin = data?.date_begin ? this.parseDateDMY(String(data.date_begin)) : null;
        this.dateEnd = data?.date_end ? this.parseDateDMY(String(data.date_end)) : null;
        this.isLevel = !!data?.is_level;
        this.canEdit = data?.can_edit !== false;
        this.lastApprovedDate = data?.last_approved_date
          ? this.parseDateDMY(String(data.last_approved_date))
          : null;
        this.isPreorder = !!data?.is_preorder;
        this.processData(raw);
        if (this.isLevel) {
          this.buildLevelRanges(data?.level_dates || []);
          this.ensureLevelsLoaded();
        }
        const pRows = progressResp?.data?.data;
        if (pRows && pRows.length) {
          const p = pRows[0];
          const toNum = (v) => parseFloat(String(v).replace(',', '.')) || 0;
          this.progressData = {
            smeta: toNum(p.smeta_amount),
            required: toNum(p.required_amount),
            ordered: toNum(p.ordered_amount),
            delivered: toNum(p.delivered_amount),
          };
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
        this.$nextTick(() => this.measureThead());
      }
    },

    measureThead() {
      if (this.$refs.headerRow1) {
        this.headerRow1Height = this.$refs.headerRow1.offsetHeight;
      }
      if (this.$refs.headerRow2) {
        this.headerRow2Height = this.$refs.headerRow2.offsetHeight;
      }
      if (this.$refs.thead) {
        this.theadHeight = this.$refs.thead.offsetHeight;
      }
      if (this.$refs.levelBody) {
        this.levelBodyHeight = this.$refs.levelBody.offsetHeight;
      } else {
        this.levelBodyHeight = 0;
      }
    },

    processData(raw) {
      const allDates = new Set();

      for (const mat of raw) {
        mat.entries = [];
        mat._dateMap = {};

        for (const block of mat.blocks || []) {
          const entry = {
            entrance: block.entrance,
            level_num: block.level_num,
            level_name: block.level_name,
            required_material_id: block.required_material_id || mat.required_material_id,
            label: `Блок ${block.entrance}`,
            smeta_amount: block.smeta_amount || 0,
            unit_name: mat.unit_name || '',
            total_required: block.total_required || 0,
            total_delivered: block.total_delivered || 0,
            _dateItems: {},
          };

          for (const ri of block.required_items || []) {
            const d = ri.shipping_date;
            if (!d) continue;
            allDates.add(d);

            if (!entry._dateItems[d]) {
              entry._dateItems[d] = {
                amount: 0,
                delivered: 0,
                required_item_id: null,
                approved: false,
              };
            }
            entry._dateItems[d].amount += ri.amount || 0;
            entry._dateItems[d].delivered += ri.delivered || 0;
            if (ri.approved) {
              entry._dateItems[d].approved = true;
            }
            if (ri.required_item_id) {
              entry._dateItems[d].required_item_id = ri.required_item_id;
            }
          }

          mat.entries.push(entry);
        }

        this.assignSmetaCaps(mat);
        this.buildMaterialDateMap(mat);
      }

      this.calendarDates = this.generateCalendarDates(allDates);
      this.materials = raw;
    },

    assignSmetaCaps(mat) {
      const entries = mat.entries || [];
      if (!entries.length) return;
      entries.forEach(e => { e.smeta_cap = Number(e.smeta_amount) || 0; });
    },

    generateCalendarDates(existingDates) {
      let minDate, maxDate;

      if (this.dateBegin && this.dateEnd) {
        minDate = new Date(this.dateBegin);
        maxDate = new Date(this.dateEnd);
      } else {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        minDate = new Date(today);
        maxDate = new Date(today);
        maxDate.setDate(maxDate.getDate() + 60);
        for (const d of existingDates) {
          const dt = new Date(d);
          if (dt < minDate) minDate = new Date(dt);
          if (dt > maxDate) maxDate = new Date(dt);
        }
      }

      const minDay = minDate.getDay();
      minDate.setDate(minDate.getDate() - (minDay === 0 ? 6 : minDay - 1));

      const maxDay = maxDate.getDay();
      if (maxDay !== 0) maxDate.setDate(maxDate.getDate() + (7 - maxDay));

      const dates = [];
      const current = new Date(minDate);
      while (current <= maxDate) {
        dates.push(this.toDateString(current));
        current.setDate(current.getDate() + 1);
      }
      return dates;
    },

    toDateString(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },

    buildMaterialDateMap(mat) {
      mat._dateMap = {};
      for (const entry of mat.entries) {
        for (const [d, vals] of Object.entries(entry._dateItems)) {
          if (!mat._dateMap[d])
            mat._dateMap[d] = { amount: 0, delivered: 0 };
          mat._dateMap[d].amount += vals.amount || 0;
          mat._dateMap[d].delivered += vals.delivered || 0;
        }
      }
    },

    toggleExpand(materialId) {
      this.expanded = {
        ...this.expanded,
        [materialId]: !this.expanded[materialId],
      };
    },

    expandAll() {
      const exp = {};
      for (const mat of this.materials) {
        exp[mat.material_id] = true;
      }
      this.expanded = exp;
    },

    collapseAll() {
      this.expanded = {};
    },

    getWeekKey(dateStr) {
      const d = new Date(dateStr);
      const day = d.getDay();
      const diff = (day === 0 ? -6 : 1) - day;
      const monday = new Date(d);
      monday.setDate(d.getDate() + diff);
      return this.toDateString(monday);
    },

    formatShortDate(dateStr) {
      const parts = dateStr.split('-');
      return `${parseInt(parts[2])}.${parts[1]}`;
    },

    getColAggregatedVal(dateMap, col, field) {
      let sum = 0;
      for (const d of col.dates) {
        const item = dateMap && dateMap[d];
        if (item) sum += item[field] || 0;
      }
      if (!sum) return '';
      return parseFloat(sum.toFixed(2));
    },

    getDayNum(dateStr) {
      return parseInt(dateStr.split("-")[2]);
    },

    getMatDateVal(mat, date, field) {
      const entry = mat._dateMap && mat._dateMap[date];
      if (!entry) return "";
      const val = entry[field];
      if (!val) return "";
      return parseFloat(Number(val).toFixed(4));
    },

    getEntryAmount(entry, date) {
      const item = entry._dateItems[date];
      return item && item.amount ? item.amount : "";
    },

    getEntryDelivered(entry, date) {
      const item = entry._dateItems[date];
      return item && item.delivered ? item.delivered : "";
    },

    isDateComplete(entry, date) {
      const item = entry._dateItems[date];
      return item && item.amount && item.amount === item.delivered;
    },

    getEntryTotalAmount(entry) {
      let sum = 0;
      for (const di of Object.values(entry._dateItems)) {
        sum += di.amount || 0;
      }
      return sum;
    },

    async refreshItems() {
      try {
        const resp = await instance().get(`/required/${this.id}/items/`);
        const data = resp.data;
        const raw = data?.data || [];
        this.processData(raw);
        if (data?.is_level) {
          this.buildLevelRanges(data?.level_dates || []);
        }
        this.$nextTick(() => this.measureThead());
      } catch (e) {
        console.error(e);
      }
    },

    debouncedRefresh() {
      if (this._refreshTimer) clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(() => {
        const active = document.activeElement;
        const isEditingCell = active && active.classList.contains('cell-input');
        if (isEditingCell || this._pendingSaves > 0) {
          this.debouncedRefresh();
          return;
        }
        this.refreshItems();
      }, 1500);
    },

    applyLocalUpdate(material, entry, date, newVal, requiredItemId) {
      if (!entry._dateItems[date]) {
        entry._dateItems[date] = { amount: 0, delivered: 0, required_item_id: null };
      }
      entry._dateItems[date].amount = newVal;
      if (requiredItemId) {
        entry._dateItems[date].required_item_id = requiredItemId;
      }
      let sum = 0;
      for (const di of Object.values(entry._dateItems)) {
        sum += di.amount || 0;
      }
      entry.total_required = sum;
      this.buildMaterialDateMap(material);
    },

    async onAmountBlur(event, material, entry, date) {
      if (!this.canEdit) return;
      const raw = event.target.value;
      let newVal = raw === "" ? 0 : parseFloat(raw);
      if (isNaN(newVal)) return;

      const existing = entry._dateItems[date];
      const oldVal = existing ? existing.amount || 0 : 0;
      if (newVal === oldVal) return;
      if (newVal === 0 && !existing) return;

      if (this.isEditLocked(entry, date, material)) {
        event.target.value = oldVal || "";
        return;
      }

      if (newVal < 0) {
        event.target.value = oldVal || "";
        return;
      }

      if (!entry.required_material_id) {
        alert('Ошибка: материал не привязан. Перезагрузите страницу.');
        event.target.value = oldVal || "";
        return;
      }

      const prevItemId = existing?.required_item_id || null;
      this.applyLocalUpdate(material, entry, date, newVal, prevItemId);

      this._pendingSaves++;
      try {
        const resp = await instance().post(`/required/${this.id}/upd-item/`, {
          required_item_id: prevItemId,
          entrance: entry.entrance,
          level_num: entry.level_num,
          required_material_id: entry.required_material_id,
          amount: newVal,
          shipping_date: date,
        }, { _skipErrorToast: true });

        if (resp.data?.error) {
          this.applyLocalUpdate(material, entry, date, oldVal, prevItemId);
          this.$q.dialog({ title: 'Ошибка', message: resp.data.error, ok: { label: 'OK', color: 'primary', flat: true } });
          return;
        }

        const returnedId = resp.data?.required_item_id;
        if (returnedId) {
          entry._dateItems[date].required_item_id = returnedId;
        }
        this.debouncedRefresh();
      } catch (e) {
        this.applyLocalUpdate(material, entry, date, oldVal, prevItemId);
        const msg = e.response?.data?.error || e.message || "Ошибка сохранения";
        this.$q.dialog({ title: 'Ошибка', message: msg, ok: { label: 'OK', color: 'primary', flat: true } });
      } finally {
        this._pendingSaves--;
      }
    },

    async onWeekAmountBlur(event, material, entry, col) {
      if (!this.canEdit) return;
      const raw = event.target.value;
      let newVal = raw === "" ? 0 : parseFloat(raw);
      if (isNaN(newVal)) return;

      const weekOldVal = this.getColAggregatedVal(entry._dateItems, col, 'amount') || 0;
      if (newVal === weekOldVal) return;

      const monday = col.dates[0];
      if (this.isEditLocked(entry, monday, material)) {
        event.target.value = weekOldVal || "";
        return;
      }

      if (newVal < 0) {
        event.target.value = weekOldVal || "";
        return;
      }

      if (this.hasNonMondayValues(entry, col)) {
        event.target.value = weekOldVal || "";
        this.$q.notify({ type: 'warning', message: 'Нельзя редактировать по неделям: в этой неделе уже есть данные по дням' });
        return;
      }

      if (!entry.required_material_id) {
        alert('Ошибка: материал не привязан. Перезагрузите страницу.');
        event.target.value = weekOldVal || "";
        return;
      }

      const mondayItem = entry._dateItems[monday];
      const prevItemId = mondayItem?.required_item_id || null;
      this.applyLocalUpdate(material, entry, monday, newVal, prevItemId);

      this._pendingSaves++;
      try {
        const resp = await instance().post(`/required/${this.id}/upd-item/`, {
          required_item_id: prevItemId,
          entrance: entry.entrance,
          level_num: entry.level_num,
          required_material_id: entry.required_material_id,
          amount: newVal,
          shipping_date: monday,
        }, { _skipErrorToast: true });

        if (resp.data?.error) {
          this.applyLocalUpdate(material, entry, monday, weekOldVal, prevItemId);
          this.$q.dialog({ title: 'Ошибка', message: resp.data.error, ok: { label: 'OK', color: 'primary', flat: true } });
          return;
        }

        const returnedId = resp.data?.required_item_id;
        if (returnedId) {
          entry._dateItems[monday].required_item_id = returnedId;
        }
        this.debouncedRefresh();
      } catch (e) {
        this.applyLocalUpdate(material, entry, monday, weekOldVal, prevItemId);
        const msg = e.response?.data?.error || e.message || "Ошибка сохранения";
        this.$q.dialog({ title: 'Ошибка', message: msg, ok: { label: 'OK', color: 'primary', flat: true } });
      } finally {
        this._pendingSaves--;
      }
    },

    async saveEntryCol(mat, entry, col, newVal) {
      const monday = col.dates[0];
      if (this.isEditLocked(entry, monday, mat)) return;

      const oldVal = this.getColAggregatedVal(entry._dateItems, col, 'amount') || 0;
      if (Math.abs(newVal - oldVal) < 1e-6) return;

      if (!entry.required_material_id) return;

      const mondayItem = entry._dateItems[monday];
      const prevItemId = mondayItem?.required_item_id || null;
      this.applyLocalUpdate(mat, entry, monday, newVal, prevItemId);

      this._pendingSaves++;
      try {
        const resp = await instance().post(`/required/${this.id}/upd-item/`, {
          required_item_id: prevItemId,
          entrance: entry.entrance,
          level_num: entry.level_num,
          required_material_id: entry.required_material_id,
          amount: newVal,
          shipping_date: monday,
        }, { _skipErrorToast: true });

        if (resp.data?.error) {
          this.applyLocalUpdate(mat, entry, monday, oldVal, prevItemId);
          this.$q.dialog({ title: 'Ошибка', message: resp.data.error, ok: { label: 'OK', color: 'primary', flat: true } });
          return;
        }

        const returnedId = resp.data?.required_item_id;
        if (returnedId && entry._dateItems[monday]) {
          entry._dateItems[monday].required_item_id = returnedId;
        }
      } catch (e) {
        this.applyLocalUpdate(mat, entry, monday, oldVal, prevItemId);
        const msg = e.response?.data?.error || e.message || 'Ошибка сохранения';
        this.$q.dialog({ title: 'Ошибка', message: msg, ok: { label: 'OK', color: 'primary', flat: true } });
      } finally {
        this._pendingSaves--;
      }
    },

    async onMatAmountBlur(event, mat, col) {
      if (!this.canEdit) return;
      if (this.isMatColLocked(mat, col)) {
        event.target.value = this.getColAggregatedVal(mat._dateMap, col, 'amount') || '';
        return;
      }
      const raw = event.target.value;
      const totalAmount = raw === '' ? 0 : parseFloat(raw);
      if (isNaN(totalAmount) || totalAmount < 0) {
        event.target.value = this.getColAggregatedVal(mat._dateMap, col, 'amount') || '';
        return;
      }

      const monday = col.dates[0];
      const blockedEntry = mat.entries.find(e => this.hasNonMondayValues(e, col));
      if (blockedEntry) {
        event.target.value = this.getColAggregatedVal(mat._dateMap, col, 'amount') || '';
        this.$q.notify({ type: 'warning', message: 'Нельзя редактировать по неделям: в этой неделе уже есть данные по дням' });
        return;
      }

      let remaining = parseFloat(totalAmount.toFixed(2));

      for (const entry of mat.entries) {
        if (this.isEditLocked(entry, monday, mat)) continue;
        if (this.hasNonMondayValues(entry, col)) continue;
        const currentColVal = parseFloat((this.getColAggregatedVal(entry._dateItems, col, 'amount') || 0).toFixed(2));
        const otherRequired = parseFloat(((entry.total_required || 0) - currentColVal).toFixed(2));
        const capacity = this.isPreorder
          ? remaining
          : parseFloat(Math.max(0, (entry.smeta_cap || 0) - otherRequired).toFixed(2));
        const allocate = parseFloat(Math.min(remaining, capacity).toFixed(2));
        remaining = parseFloat(Math.max(0, remaining - allocate).toFixed(2));
        await this.saveEntryCol(mat, entry, col, allocate);
      }

      this.$q.notify({ type: 'positive', message: 'Распределение сохранено' });
      this.debouncedRefresh();
    },

    hasNonMondayValues(entry, col) {
      for (const d of col.dates.slice(1)) {
        if ((entry._dateItems[d]?.amount || 0) > 0) return true;
      }
      return false;
    },

    getEntryAllocatedOrdered(mat, entry) {
      let remaining = mat.total_ordered || 0;
      for (const e of mat.entries) {
        const cap = Number(e.total_required) || 0;
        const allocated = Math.min(cap, Math.max(remaining, 0));
        remaining -= allocated;
        if (e === entry) return parseFloat(allocated.toFixed(4));
      }
      return 0;
    },

    getEntryAllocatedOrderedFromRequired(mat, entry) {
      let remaining = mat.ordered_from_required || 0;
      for (const e of mat.entries) {
        const cap = Number(e.total_required) || 0;
        const allocated = Math.min(cap, Math.max(remaining, 0));
        remaining -= allocated;
        if (e === entry) return parseFloat(allocated.toFixed(4));
      }
      return 0;
    },

    getEntryAllocatedOrderedWithoutRequired(mat, entry) {
      let remaining = mat.ordered_without_required || 0;
      for (const e of mat.entries) {
        const cap = Number(e.total_required) || 0;
        const allocated = Math.min(cap, Math.max(remaining, 0));
        remaining -= allocated;
        if (e === entry) return parseFloat(allocated.toFixed(4));
      }
      return 0;
    },

    isEntryOrderFull(mat, entry) {
      if (this.isPreorder) return false;
      const smetaCap = Number(entry.smeta_cap) || 0;
      if (smetaCap <= 0) return false;
      const total = Number(entry.total_required) || 0;
      return total + 1e-6 >= smetaCap;
    },

    isMatBlocked(mat) {
      const avail = (Number(mat.smeta_amount) || 0) - (Number(mat.total_required) || 0) - (Number(mat.ordered_without_required) || 0);
      return avail <= 0;
    },

    async openSmetaDetail(mat) {
      this.smetaDetailMat = mat;
      this.smetaDetailRows = [];
      this.smetaDetailDialog = true;
      this.smetaDetailLoading = true;
      try {
        const { data } = await instance().get(
          `/required/${this.id}/material-smeta-detail/`,
          { params: { material_id: mat.material_id } }
        );
        this.smetaDetailRows = data?.data || [];
      } catch (e) {
        this.$q.notify({ type: 'negative', message: 'Ошибка загрузки расшифровки сметы' });
      } finally {
        this.smetaDetailLoading = false;
      }
    },

    getEntryAllocatedDelivered(mat, entry) {
      let remaining = mat.total_delivered || 0;
      for (const e of mat.entries) {
        const cap = this.getEntryAllocatedOrdered(mat, e);
        const allocated = Math.min(cap, Math.max(remaining, 0));
        remaining -= allocated;
        if (e === entry) return allocated;
      }
      return 0;
    },

    isDateApproved(entry, date) {
      const item = entry._dateItems[date];
      return !!(item && item.approved);
    },

    isPhase1PastLocked(date) {
      return !this.lastApprovedDate && this.isDateBeforeToday(date);
    },

    isEditLocked(entry, date, mat) {
      if (!this.canEdit) return true;
      if (!this.lastApprovedDate) {
        return this.isDateBeforeToday(date);
      }
      if (this.isDateApproved(entry, date)) return true;
      if (date <= this.lastApprovedDate) return true;
      return false;
    },

    isPhase2SendHorizonLocked(date) {
      return !!this.lastApprovedDate && !!date && date <= this.lastApprovedDate;
    },

    isColAllApproved(mat, col) {
      if (!this.lastApprovedDate) return false;
      const date = col.dates[0];
      const entries = mat.entries || [];
      if (!entries.length) return false;
      return entries.every(e => this.isDateApproved(e, date));
    },

    isCellReadonly(entry, date, mat) {
      if (this.isEditLocked(entry, date, mat)) return true;
      if (this.isEntryOrderFull(mat, entry)) return true;
      if (this.isMatBlocked(mat) && !this.getEntryAmount(entry, date)) return true;
      return false;
    },

    isDayCellReadonly(entry, col, mat) {
      return this.isCellReadonly(entry, col.dates[0], mat);
    },

    isWeekCellReadonly(entry, col, mat) {
      if (this.hasNonMondayValues(entry, col)) return true;
      return this.isCellReadonly(entry, col.dates[0], mat);
    },

    isMatColLocked(mat, col) {
      const date = col.dates[0];
      if (!this.lastApprovedDate && this.isDateBeforeToday(date)) return true;
      if (this.isPhase2SendHorizonLocked(date)) return true;
      if (this.viewMode === 'day') {
        return !(mat.entries || []).some(e => !this.isEditLocked(e, date, mat));
      }
      const editableEntries = (mat.entries || []).filter(e =>
        !this.isEditLocked(e, date, mat) && !this.hasNonMondayValues(e, col)
      );
      return editableEntries.length === 0;
    },

    isMatCellReadonly(mat, col) {
      if (!this.canEdit) return true;
      if (this.viewMode === 'all' || this.viewMode === 'month') return true;
      if (this.isMatColLocked(mat, col)) return true;
      if (this.isMatBlocked(mat) && !this.getColAggregatedVal(mat._dateMap, col, 'amount')) return true;
      return false;
    },

    isWeekComplete(entry, col) {
      const amt = this.getColAggregatedVal(entry._dateItems, col, 'amount');
      const del = this.getColAggregatedVal(entry._dateItems, col, 'delivered');
      return amt && amt === del;
    },

    parseDateDMY(ddmmyyyy) {
      if (!ddmmyyyy) return null;
      if (ddmmyyyy.includes('-')) return ddmmyyyy;
      const p = ddmmyyyy.split('.');
      if (p.length !== 3) return ddmmyyyy;
      return `${p[2]}-${p[1]}-${p[0]}`;
    },

    buildLevelRanges(levelDates) {
      this.levelRanges = (levelDates || []).map(ld => ({
        required_level_id: ld.required_level_id,
        level_num: ld.level_num,
        start_date: this.parseDateDMY(ld.start_date),
        end_date: this.parseDateDMY(ld.end_date),
      })).filter(ld => ld.start_date && ld.end_date);
    },

    async loadLevels() {
      try {
        const { data } = await instance().get(`/required/${this.id}/levels/`);
        this.levels = (data?.data || []).map(lv => ({ ...lv }));
      } catch (e) {
        console.error(e);
      }
    },

    ensureLevelsLoaded() {
      if (!this.levels.length) {
        instance().get(`/required/${this.id}/levels/`).then(({ data }) => {
          this.levels = (data?.data || []).map(lv => ({ ...lv }));
        }).catch(console.error);
      }
    },

    isoToDmy(iso) {
      if (!iso) return '';
      const p = iso.split('-');
      if (p.length !== 3) return iso;
      return `${p[2]}.${p[1]}.${p[0]}`;
    },

    dmyToIso(dmy) {
      if (!dmy) return '';
      const p = dmy.split('.');
      if (p.length !== 3) return dmy;
      return `${p[2]}-${p[1]}-${p[0]}`;
    },

    async openLevelDialog() {
      if (!this.canEdit) return;
      if (!this.levels.length) {
        try {
          const { data } = await instance().get(`/required/${this.id}/levels/`);
          this.levels = (data?.data || []).map(lv => ({ ...lv }));
        } catch (e) {
          console.error(e);
        }
      }
      const dates = {};
      for (const lv of this.levels) {
        const existing = this.levelRanges.find(lr => lr.level_num === lv.level_num);
        dates[lv.level_num] = {
          start: existing ? this.isoToDmy(existing.start_date) : '',
          end: existing ? this.isoToDmy(existing.end_date) : '',
          id: existing?.required_level_id || null,
        };
      }
      this.levelDates = dates;
      this.showLevelDialog = true;
    },

    async onLevelDateChange(levelNum) {
      const d = this.levelDates[levelNum];
      if (!d || !d.start || !d.end) return;
      const startIso = this.dmyToIso(d.start);
      const endIso = this.dmyToIso(d.end);
      if (startIso > endIso) return;

      try {
        if (d.id) {
          await instance().post('/required/del-level/', { required_level_id: d.id });
        }
        await instance().post(`/required/${this.id}/upd-level/`, {
          level_num: levelNum,
          start_date: startIso,
          end_date: endIso,
        });
        await this.reloadLevelDates();
        this.syncLevelDatesForm();
      } catch (e) {
        console.error(e);
      }
    },

    async deleteLevelRange(levelNum) {
      const d = this.levelDates[levelNum];
      if (!d || !d.id) return;
      try {
        await instance().post('/required/del-level/', { required_level_id: d.id });
        await this.reloadLevelDates();
        this.levelDates[levelNum] = { start: '', end: '', id: null };
      } catch (e) {
        console.error(e);
      }
    },

    syncLevelDatesForm() {
      for (const lv of this.levels) {
        const existing = this.levelRanges.find(lr => lr.level_num === lv.level_num);
        this.levelDates[lv.level_num] = {
          start: existing ? this.isoToDmy(existing.start_date) : '',
          end: existing ? this.isoToDmy(existing.end_date) : '',
          id: existing?.required_level_id || null,
        };
      }
    },

    async reloadLevelDates() {
      try {
        const { data } = await instance().get(`/required/${this.id}/items/`);
        this.buildLevelRanges(data?.level_dates || []);
        this.$nextTick(() => this.measureThead());
      } catch (e) {
        console.error(e);
      }
    },

    async onAddMaterialClick() {
      if (!this.canEdit) return;
      this.closeTypeSearch();
      this.inlineSelectedMaterial = null;
      this.showMaterialSearch = true;
      this.isLoadingMaterials = true;
      try {
        const { data } = await instance().get(`/required/${this.id}/materials/`);
        this.availableMaterials = data?.data || [];
        this.filteredMaterials = this.availableMaterials;
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoadingMaterials = false;
        this.$nextTick(() => {
          this.$refs.materialSearchRef?.showPopup();
          this.$refs.materialSearchRef?.focus();
        });
      }
    },

    closeMaterialSearch() {
      this.showMaterialSearch = false;
      this.inlineSelectedMaterial = null;
    },

    onFilterMaterials(val, update) {
      update(() => {
        if (!val) {
          this.filteredMaterials = this.availableMaterials;
        } else {
          const q = val.toLowerCase();
          this.filteredMaterials = this.availableMaterials.filter(
            m => (m.material_name || '').toLowerCase().includes(q)
          );
        }
      });
    },

    async onInlineMaterialPick(opt) {
      if (!opt || opt.is_used) return;
      const materialId = opt.material_id;
      if (!materialId) return;

      this.isSavingMaterial = true;
      try {
        await instance().post(`/required/${this.id}/add-material/`, {
          material_id: materialId,
        });
        this.showMaterialSearch = false;
        this.inlineSelectedMaterial = null;
        await this.loadData();
      } catch (e) {
        console.error(e);
      } finally {
        this.isSavingMaterial = false;
      }
    },

    async onAddByTypeClick() {
      if (!this.canEdit) return;
      this.closeMaterialSearch();
      this.inlineSelectedType = null;
      this.showTypeSearch = true;
      this.isLoadingTypes = true;
      try {
        const { data } = await instance().get(`/required/${this.id}/required-type/`);
        this.availableTypes = data?.data || [];
        this.filteredTypes = this.availableTypes;
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoadingTypes = false;
        this.$nextTick(() => {
          this.$refs.typeSearchRef?.showPopup();
          this.$refs.typeSearchRef?.focus();
        });
      }
    },

    closeTypeSearch() {
      this.showTypeSearch = false;
      this.inlineSelectedType = null;
    },

    onFilterTypes(val, update) {
      update(() => {
        if (!val) {
          this.filteredTypes = this.availableTypes;
        } else {
          const q = val.toLowerCase();
          this.filteredTypes = this.availableTypes.filter(
            t => (t.required_type_name || '').toLowerCase().includes(q)
          );
        }
      });
    },

    async onInlineTypePick(opt) {
      if (!opt || opt.is_used) return;
      const typeId = opt.required_type_id;
      if (!typeId) return;

      this.isSavingType = true;
      try {
        await instance().post('/required/required-material-add-by-type/', {
          required_id: this.id,
          required_type_id: typeId,
        });
        this.showTypeSearch = false;
        this.inlineSelectedType = null;
        await this.loadData();
      } catch (e) {
        console.error(e);
      } finally {
        this.isSavingType = false;
      }
    },

    isDateBeforeToday(dateStr) {
      if (!dateStr) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const d = new Date(dateStr);
      d.setHours(0, 0, 0, 0);
      return d < today;
    },

    onDeleteMaterial(mat) {
      if (!this.canEdit) return;
      const rmId = mat.required_material_id;
      if (!rmId) return;

      this.$q.dialog({
        title: 'Удалить материал',
        message: `Удалить «${mat.material_name}» из потребности? Все связанные записи будут удалены.`,
        cancel: { label: 'Отмена', flat: true, noCaps: true },
        ok: { label: 'Удалить', color: 'negative', noCaps: true },
        persistent: true,
      }).onOk(async () => {
        try {
          await instance().post('/required/required-material-del/', {
            required_material_id: rmId,
          });
          await this.loadData();
        } catch (e) {
          const msg = e.response?.data?.error || e.message || 'Ошибка удаления';
          this.$q.notify({ type: 'negative', message: msg });
        }
      });
    },

    async openDelegatesDialog() {
      if (!this.canEdit) return;
      this.delegatesDialog = true;
      await Promise.all([
        this.loadDelegates(),
        this.loadDelegateEmployees(),
      ]);
    },

    async loadDelegates() {
      this.delegatesLoading = true;
      try {
        const resp = await instance().get(`/required/${this.id}/delegates/`);
        this.delegates = resp.data?.data || [];
      } catch (e) {
        const msg = e.response?.data?.error || e.message || 'Ошибка загрузки делегатов';
        this.$q.notify({ type: 'negative', message: msg });
        this.delegates = [];
      } finally {
        this.delegatesLoading = false;
      }
    },

    async loadDelegateEmployees() {
      if (this.delegateEmployees?.length) return;
      this.isLoadingDelegateEmployees = true;
      try {
        const resp = await instance().get('/required/read-employee-for-required-type/');
        const rows = resp.data?.data || [];
        this.delegateEmployees = rows;
        this.filteredDelegateEmployees = rows;
      } catch (e) {
        const msg = e.response?.data?.error || e.message || 'Ошибка загрузки сотрудников';
        this.$q.notify({ type: 'negative', message: msg });
        this.delegateEmployees = [];
        this.filteredDelegateEmployees = [];
      } finally {
        this.isLoadingDelegateEmployees = false;
      }
    },

    onFilterDelegateEmployees(val, update) {
      update(() => {
        const q = (val || '').toLowerCase();
        if (!q) {
          this.filteredDelegateEmployees = this.delegateEmployees;
          return;
        }
        this.filteredDelegateEmployees = (this.delegateEmployees || []).filter(e =>
          String(e.fio || '').toLowerCase().includes(q)
        );
      });
    },

    onNewDelegateEditToggle(val) {
      if (val) this.newDelegateCanView = true;
    },

    async saveNewDelegate() {
      if (!this.canEdit) return;
      if (!this.newDelegateEmployeeId) return;

      const canEdit = !!this.newDelegateCanEdit;
      const canView = !!this.newDelegateCanView || canEdit;
      if (!canView && !canEdit) return;

      this.isSavingDelegate = true;
      try {
        await instance().post(`/required/${this.id}/delegates/upd/`, {
          delegate_employee_id: this.newDelegateEmployeeId,
          can_view: canView,
          can_edit: canEdit,
        });
        this.$q.notify({ type: 'positive', message: 'Сохранено' });
        this.newDelegateEmployeeId = null;
        this.newDelegateCanEdit = false;
        this.newDelegateCanView = true;
        await this.loadDelegates();
      } catch (e) {
        const msg = e.response?.data?.error || e.message || 'Ошибка сохранения';
        this.$q.notify({ type: 'negative', message: msg });
      } finally {
        this.isSavingDelegate = false;
      }
    },

    onDelegateEditToggle(d) {
      if (d.can_edit) d.can_view = true;
      if (!d.can_view && !d.can_edit) d.can_view = true;
    },

    onDelegateViewToggle(d) {
      if (d.can_edit) d.can_view = true;
      if (!d.can_view && !d.can_edit) d.can_view = true;
    },

    async saveDelegateRow(d) {
      if (!this.canEdit) return;
      if (!d?.delegate_employee_id) return;
      if (!d.can_view && !d.can_edit) return;

      this.savingDelegateEmployeeId = d.delegate_employee_id;
      try {
        await instance().post(`/required/${this.id}/delegates/upd/`, {
          delegate_employee_id: d.delegate_employee_id,
          can_view: !!d.can_view || !!d.can_edit,
          can_edit: !!d.can_edit,
        });
        this.$q.notify({ type: 'positive', message: 'Сохранено' });
        await this.loadDelegates();
      } catch (e) {
        const msg = e.response?.data?.error || e.message || 'Ошибка сохранения';
        this.$q.notify({ type: 'negative', message: msg });
      } finally {
        this.savingDelegateEmployeeId = null;
      }
    },

    deleteDelegateRow(d) {
      if (!this.canEdit) return;
      const id = d?.required_delegate_id;
      if (!id) return;

      this.$q.dialog({
        title: 'Удалить делегата',
        message: `Удалить делегирование для «${d.delegate_fio || d.delegate_employee_id}»?`,
        cancel: { label: 'Отмена', flat: true, noCaps: true },
        ok: { label: 'Удалить', color: 'negative', noCaps: true },
        persistent: true,
      }).onOk(async () => {
        this.deletingDelegateId = id;
        try {
          await instance().post('/required/delegates/del/', { required_delegate_id: id });
          this.$q.notify({ type: 'positive', message: 'Удалено' });
          await this.loadDelegates();
        } catch (e) {
          const msg = e.response?.data?.error || e.message || 'Ошибка удаления';
          this.$q.notify({ type: 'negative', message: msg });
        } finally {
          this.deletingDelegateId = null;
        }
      });
    },

    async onApprove() {
      if (!this.canEdit) return;
      this.isApproving = true;
      try {
        const resp = await instance().post('/required/approve/', {
          required_id: this.id,
        });
        if (resp.data?.error) {
          this.$q.notify({ type: 'negative', message: resp.data.error });
          return;
        }
        this.$q.notify({ type: 'positive', message: 'Успешно отправлено' });
        await this.loadData();
      } catch (e) {
        const msg = e.response?.data?.error || e.message || 'Ошибка отправки';
        this.$q.notify({ type: 'negative', message: msg });
      } finally {
        this.isApproving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.required-items-page {
  padding: 4px 10px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
}

/* ── Toolbar ── */
.ri-toolbar {
  margin-bottom: 6px;
}
.ri-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  background: #f8faf9;
  border: 1px solid #e4ece7;
  border-radius: 10px;
  margin-bottom: 6px;
}
.ri-expand-btns {
  border: 1px solid #d4ddd7;
  border-radius: 6px;
}

/* ── Loader ── */
.ri-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
}
.ri-loader__text {
  margin-top: 12px;
  color: #78909c;
  font-size: 14px;
}

.ri-progress-section {
  margin-bottom: 10px;
}

.ri-progress-bar {
  position: relative;
  height: 20px;
  background: #eceff1;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.06);
}

.ri-progress-segment {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 0 10px 10px 0;
  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.ri-progress--required { background: linear-gradient(90deg, #fb8c00, #ffa726); z-index: 1; }
.ri-progress--ordered  { background: linear-gradient(90deg, #1e88e5, #42a5f5); z-index: 2; }
.ri-progress--delivered { background: linear-gradient(90deg, #43a047, #66bb6a); z-index: 3; }

.ri-progress-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-top: 4px;
}

.ri-legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.ri-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ri-legend-text {
  font-size: 11px;
  color: #546e7a;
  white-space: nowrap;
}

.ri-progress-tooltip {
  font-size: 12px;
  line-height: 1.6;
}

.ri-tooltip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.ri-tooltip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}


.required-items-table-wrapper {
  overflow: auto;
  flex: 1;
  min-height: 0;
  border: 1px solid #dce4df;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
}

.ri-table {
  width: max-content;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
}

.ri-th {
  padding: 3px 3px;
  text-align: center;
  font-weight: 500;
  white-space: nowrap;
  border-bottom: 1px solid #e6e8ef;
  border-right: 1px solid #e6e8ef;
  background: #f5f7fa;
  position: sticky;
  top: 0;
  z-index: 5;
}

.ri-th--fixed {
  background: #f0f2f5;
}

.ri-th--clickable {
  cursor: pointer;

  &:hover {
    filter: brightness(0.93);
  }
}

.ri-sticky {
  position: sticky;
  z-index: 2;
}

.ri-th.ri-sticky {
  z-index: 6;
}

.ri-sticky--0 { left: 0; min-width: 32px; width: 32px; }
.ri-sticky--1 { left: 32px; min-width: 240px; width: 240px; }
.ri-sticky--2 { left: 272px; min-width: 90px; width: 90px; }
.ri-sticky--3 { left: 362px; min-width: 80px; width: 80px; }
.ri-sticky--4 { left: 442px; min-width: 80px; width: 80px; }
.ri-sticky--5 {
  left: 522px;
  min-width: 88px;
  width: 88px;
}
.ri-sticky--6 {
  left: 610px;
  min-width: 80px;
  width: 80px;
  border-right: 2px solid #ccd0d8;
}

.ri-th--avail {
  text-align: center;
  vertical-align: middle;
  font-size: 10px;
  line-height: 1.15;
  font-weight: 600;
  padding: 4px 2px;
}

.ri-th-avail-lines {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ri-th-avail-line {
  display: block;
}

.ri-td--avail-col {
  vertical-align: middle;
}

.ri-row--material .ri-sticky { background: #fafafa; }
.ri-row--material:hover .ri-sticky { background: #f0f6ff; }
.ri-row--entry .ri-sticky { background: #fff; }
.ri-row--entry:hover .ri-sticky { background: #f5f5f5; }

.ri-th--name {
  min-width: 200px;
  max-width: 240px;
  text-align: center;
}

.ri-th--month {
  font-weight: 600;
  font-size: 12px;
  text-transform: capitalize;
  text-align: left;
}

.ri-month-label {
  position: sticky;
  left: 524px;
}

.ri-th--day {
  font-size: 10px;
  padding: 2px 2px;
}

.ri-th--sub {
  font-size: 9px;
  font-weight: 400;
  padding: 1px 2px;
}

.ri-th--month.ri-month--0 { background: #d4e4f7; }
.ri-th--month.ri-month--1 { background: #f1e0ce; }

.ri-th--day.ri-month--0 { background: #e0ebf9; }
.ri-th--day.ri-month--1 { background: #f7ebe0; }

.ri-th--sub.ri-month--0 { background: #eaf1fb; }
.ri-th--sub.ri-month--1 { background: #fbf0ea; }

.ri-td.ri-month--0 { background: #f5f9ff; }
.ri-td.ri-month--1 { background: #fff9f5; }

.ri-row--material .ri-td.ri-month--0 { background: #edf3fb; }
.ri-row--material .ri-td.ri-month--1 { background: #fbf1ed; }
.ri-row--material:hover .ri-td.ri-month--0 { background: #e0ecf9; }
.ri-row--material:hover .ri-td.ri-month--1 { background: #f9e8e0; }

.ri-row--entry .ri-td.ri-month--0 { background: #f5f9ff; }
.ri-row--entry .ri-td.ri-month--1 { background: #fff9f5; }
.ri-row--entry:hover .ri-td.ri-month--0 { background: #eaf1fb; }
.ri-row--entry:hover .ri-td.ri-month--1 { background: #fbf0ea; }

.ri-td {
  padding: 2px 3px;
  border-bottom: 1px solid #e6e8ef;
  border-right: 1px solid #e6e8ef;
  vertical-align: middle;
  white-space: nowrap;
}

.ri-td--name {
  white-space: normal;
  word-break: break-word;
  max-width: 240px;
  cursor: pointer;
}

.ri-name-cell {
  display: flex;
  align-items: center;
  gap: 2px;
}

.ri-name-text {
  flex: 1;
  min-width: 0;
}

.ri-delete-btn {
  opacity: 0;
  transition: opacity 0.15s ease;
  flex-shrink: 0;
}

.ri-row--material:hover .ri-delete-btn {
  opacity: 1;
}

.ri-td--entry-name {
  padding-left: 28px !important;
  color: #555;
  white-space: normal;
  word-break: break-word;
  max-width: 240px;
}

.ri-chip--preorder {
  font-size: 10px !important;
  height: 16px !important;
  vertical-align: middle;
  :deep(.q-chip__content) {
    padding: 0 4px;
  }
}

.ri-td--num {
  text-align: right;
  white-space: nowrap;
}

.ri-td--num.ri-td--avail-col {
  text-align: center;
}

.ri-td--date {
  font-size: 11px;
  color: #666;
}

.ri-td--delivered {
  font-size: 11px;
  color: #888;
  background: #fafafa;
}

.ri-td--input {
  padding: 1px !important;
  max-width: 44px;
  background: #fff !important;
}

.ri-td--input.ri-td--has-value {
  background: #e8f5e9 !important;
}

.ri-td--has-value {
  background: #e0f2f1 !important;
}
.ri-td--has-value .cell-input {
  font-weight: 600;
  color: #00695c;
}

.ri-td--complete {
  background: #e0f2f1 !important;
  color: #00695c !important;
  font-weight: 600;
}

.ri-val {
  font-weight: 600;
}
.ri-val--required { color: #e65100; }
.ri-val--ordered  { color: #1565c0; }
.ri-val--delivered { color: #2e7d32; }
.ri-val--slash {
  color: #b0bec5;
  font-weight: 400;
}
.ri-val--denom {
  color: #78909c;
  font-weight: 400;
}
.ri-val--smeta-link {
  cursor: pointer;
  text-decoration: underline dotted;
  &:hover {
    color: #1976d2;
  }
}
.smeta-detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  th, td {
    padding: 6px 10px;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
  }
  th {
    font-weight: 600;
    background: #f5f5f5;
  }
  .smeta-detail-total td {
    border-top: 2px solid #bdbdbd;
    background: #fafafa;
  }
}
.ri-val--unit {
  color: #90a4ae;
  font-size: 10px;
  font-weight: 400;
}

.ri-row--material-sticky > td {
  position: sticky;
  top: var(--thead-h, 0px);
  z-index: 1;
  background: #fafafa;
}

.ri-row--material-sticky:hover > td {
  background: #f0f6ff;
}

.ri-row--material-sticky > td.ri-sticky {
  z-index: 3;
}

.ri-row--material {
  font-weight: 600;
  background: #fafafa;
  cursor: pointer;

  &:hover {
    background: #f0f6ff;
  }
}

.ri-row--entry {
  background: #fff;

  &:hover {
    background: #f5f5f5;
  }
}

.ri-row--levels {
  background: #f0f2f5;
  font-weight: 500;
  font-size: 11px;
}

.ri-td--level-sticky {
  position: sticky;
  top: var(--header-h, 0px);
  z-index: 2;
  background: #f0f2f5;
  cursor: pointer;
}

.ri-td--level-sticky.ri-sticky {
  z-index: 4;
  background: #f0f2f5;
}

.ri-row--levels .ri-sticky {
  background: #f0f2f5;
}

.ri-td--level-label {
  font-weight: 600;
  font-size: 12px;
  color: #1976d2;
  white-space: nowrap;
}

.ri-row--levels-clickable {
  cursor: pointer;

  &:hover td {
    background: #e8eaf0 !important;
  }
}

.ri-row--levels-disabled {
  cursor: default;

  &:hover td {
    background: inherit !important;
  }
}

.ri-btn-wrap {
  display: inline-block;
  position: relative;
}

.ri-level-edit-icon {
  opacity: 0;
  margin-left: 4px;
  color: #90a4ae;
  transition: opacity 0.15s;
}

.ri-row--levels-clickable:hover .ri-level-edit-icon {
  opacity: 1;
}

.ri-td--level-cell {
  text-align: center;
  font-size: 11px;
}

.ri-td--level-assigned {
  background: #e3f2fd !important;
}

.ri-level-num {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  border-radius: 4px;
  background: #1976d2;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}

.ri-level-dialog {
  min-width: 460px;
  max-width: 560px;
}

.ri-level-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 4px !important;
}

.ri-level-dialog__body {
  padding-top: 4px !important;
}

.ri-level-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ri-level-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ri-level-row__label {
  min-width: 70px;
  font-size: 13px;
  font-weight: 600;
  color: #37474f;
  white-space: nowrap;
}

.ri-level-date {
  flex: 1;
  min-width: 0;

  :deep(.q-field__control) {
    height: 34px;
    min-height: 34px;
  }
  :deep(.q-field__native) {
    font-size: 12px;
    padding-top: 0;
    padding-bottom: 0;
  }
  :deep(.q-field__label) {
    font-size: 11px;
  }
}

.expand-icon {
  color: #00897b;
  vertical-align: middle;
  margin-right: 4px;
}

.ri-action-buttons {
  display: flex;
  gap: 8px;
}

.ri-action-btn {
  border-radius: 8px !important;
  padding: 4px 14px !important;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0;
  min-height: 34px;
  box-shadow: none !important;
  transition: background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10) !important;
  }
}

.ri-inline-search {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ri-inline-select {
  width: 340px;

  :deep(.q-field__control) {
    border-radius: 8px !important;
    &::before { border-radius: 8px !important; }
    &::after  { border-radius: 8px !important; }
  }
  :deep(.q-field__native span) {
    font-size: 13px;
  }
}

.ri-option--used {
  opacity: 0.45;
  cursor: not-allowed !important;
  pointer-events: auto !important;
}

.ri-fade-enter-active,
.ri-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.ri-fade-enter-from,
.ri-fade-leave-to {
  opacity: 0;
  transform: translateX(12px);
}

.ri-view-toggle {
  border: 1px solid #d4ddd7;
  border-radius: 8px;
  overflow: hidden;
}

.ri-prihod-toggle {
  display: none;
  border: 1px solid #d4ddd7;
  border-radius: 6px;
  font-size: 12px;
}

.ri-month-filter {
  font-size: 12px;
  :deep(.q-field__control) {
    min-height: 28px;
    padding: 0 8px;
  }
  :deep(.q-field__native) {
    font-size: 12px;
    padding: 2px 0;
  }
}

.ri-approve-btn {
  border-radius: 8px !important;
  padding: 4px 18px !important;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0;
  min-height: 34px;
  flex-shrink: 0;
}

.ri-td--readonly {
  background: #f8f9fa;
  font-size: 11px;
  color: #666;
}

.ri-td--past {
  background: #f0f0f0 !important;
  color: #999 !important;
}

.ri-td--approved {
  background: #e8f5e9 !important;
  color: #2e7d32 !important;
  font-weight: 600;
}

.cell-input {
  width: 100%;
  min-width: 24px;
  max-width: 40px;
  padding: 1px 2px;
  border: 1px solid transparent;
  border-radius: 3px;
  background: transparent;
  text-align: right;
  font-size: 11px;
  outline: none;
  box-sizing: border-box;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:hover {
    border-color: #ccc;
  }

  &:focus {
    border-color: #00897b;
    background: #fff;
    box-shadow: 0 0 0 1px #00897b inset;
  }
}
</style>

<style>
.ri-header-tip {
  font-size: 13px !important;
  padding: 6px 12px !important;
  white-space: nowrap;
}
</style>
